import { DropDownModel } from "@/models";

// ELA status and correction reason codes are still placeholders.
// TODO: replace with real CALPADS reference data (likely added to CoreDataModel) once the backend team provides it.

export const elaStatusCodeList: DropDownModel[] = [
  { Value: "EL", Text: "English Learner" },
  { Value: "IFEP", Text: "Initial Fluent English Proficient" },
  { Value: "RFEP", Text: "Reclassified Fluent English Proficient" },
  { Value: "EO", Text: "English Only" },
  { Value: "TBD", Text: "To Be Determined" },
];

export const correctionReasonCodeList: DropDownModel[] = [
  { Value: "CORR", Text: "Data Correction" },
  { Value: "DUP", Text: "Duplicate Record Removal" },
  { Value: "LATE", Text: "Late Submission Correction" },
];

// SPED Status and Plan Type Code below are the real, confirmed CALPADS values.
export const spedStatusList: DropDownModel[] = [
  { Value: "1", Text: "Eligible and Participating" },
  { Value: "2", Text: "Eligible and Not Participating" },
  { Value: "3", Text: "Eligible and Not Enrolled" },
  { Value: "4", Text: "Not Eligible" },
];

export const spedPlanTypeCodeList: DropDownModel[] = [
  { Value: "100", Text: "Individualized Education Program (IEP)" },
  { Value: "150", Text: "Individual Family Service Plan (IFSP)" },
];
